import { RESERVATION_ITEM } from "../../data/reservation";

export default {
  title: '取得商家預約項目',
  type: 'post',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": {
          "items": RESERVATION_ITEM
        }
      }
    },
  ]
}

